const VoucherTransactionType = {
    MULTIPLE: 1,
    SINGLE: 2
}
export default VoucherTransactionType